import { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import { Box, IconButton } from "@mui/material";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Close from "../assets/icons/close.svg";
import Selected from "../assets/icons/selector.png";
import MenuBackground from "../assets/images/dashboard/back.jpg";
import Facebook from "../assets/icons/Facebook.svg";
import Instagram from "../assets/icons/Instagram.svg";

//import ConfirmationDialog from "../../reusableComponents/ConfirmationDialog";
//import Admin from "../../../assets/images/users/Admin.svg";

const content = [
  { id: 1, text: "Home", linkUrl: "/home" },
  { id: 2, text: "About Us", linkUrl: "/aboutus" },
  { id: 3, text: "Services", linkUrl: "/services" },
  { id: 4, text: "Contact Us", linkUrl: "/contactme" },
];

export default function MenuBox({ setMenuActive, setColor }) {
  const [active, setActive] = useState();
  const navigate = useNavigate();
  const location = useLocation(); // Get current URL

  const handleNavigation = (id, url) => {
    setActive(id);
    if (id === 2) {
      setColor(true);
    } else {
      setColor(false);
    }
    navigate(url);
    setMenuActive(false);
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const matchedContent = content.find(
      (item) => currentPath.includes(item.linkUrl) // Check if item.text is part of the current URL path
    );
    if (matchedContent) {
      setActive(matchedContent.id); // Set the active tab based on URL
    } else {
      setActive(content[0].id); // Default to the first tab if no match
    }
  }, [location.pathname]); // Re-run when the URL changes

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",

        backgroundImage: `url(${MenuBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      <Box sx={{ position: "absolute", right: 10, top: 10 }}>
        <IconButton
          onClick={() => setMenuActive(false)}
          sx={{ marginRight: "15px", marginTop: "15px" }}
        >
          <img
            style={{
              height: "30px",
            }}
            src={Close}
            alt="Close"
          />
        </IconButton>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "Center",
          marginTop: "10px",
          overflowY: "scroll",
        }}
      >
        {content.map((each) => (
          <Box
            sx={{
              padding: "20px 45px",
              backgroundImage: each.id === active ? `url(${Selected})` : "",
              color: each.id !== active ? "#ffffff" : "#F04336",
              backgroundSize: "150px 40px",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              "&:hover": {
                backgroundImage: `url(${Selected})`,
                color: "#F04336",
                cursor: "pointer",
              },
            }}
          >
            <Typography
              key={each.id}
              sx={{
                fontSize: {
                  xs: "20px",
                  lg: "24px",
                },

                fontFamily: "Nunito",
                fontWeight: "1000",
                textAlign: "Left",
                textWrap: "nowrap",
                "&:hover": {
                  color: "#F04336",
                  cursor: "pointer",
                },
              }}
              onClick={() => handleNavigation(each.id, each.linkUrl)}
            >
              {each.text}
            </Typography>
          </Box>
        ))}
        <Box sx={{ display: "flex", flexDirection: "row", gap: "20px" }}>
          <Box>
            <img src={Facebook} alt="Facebook" />
          </Box>
          <Box>
            <img src={Instagram} alt="Instagram" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
